module.exports = __webpack_public_path__ + "assets/show.014a3ca5.svg";